<template>
  <!-- Modal template -->
  <admin-modal
    v-show="show"
    class="long"
    :title="title"
    :loading="loading"
    :error="errorMessage"
    @cancel="closeModal"
  >
    <!-- edit fields -->
    <template v-slot:body>
      <div class="modal__row">
        <!-- URL edting field -->
        <div class="modal__field long-field">
          <span class="modal__label">Stream URL</span>
          <input
            v-model="form.streamUrl"
            :class="{ error: !streamUrlValidStatus.valid }"
            class="modal__input"
            @input="validateModal"
          />
        </div>
        <!-- New display name -->
        <div class="modal__field long-field marginBlock">
          <span class="modal__label">New display name</span>
          <input
            v-model="form.streamDisplayName"
            :class="{ error: !streamUrlValidStatus.valid }"
            class="modal__input"
          />
        </div>
      </div>
    </template>

    <!-- footer -->
    <template v-slot:footer>
      <!-- Cancel button -->
      <div class="modal-btn cancel-btn" @click="closeModal">
        Cancel
      </div>
      <!-- Submit button -->
      <div class="modal-btn submit-btn" @click="trySubmit">
        Edit
      </div>
    </template>
  </admin-modal>
</template>

<script>
import AdminModal from "@/components/admin/modals/AdminModal.vue";

// @group Dialog
// Modal for edit stream URL
export default {
  name: "EditStreamModal",
  components: {
    /** Modal template */
    AdminModal
  },
  props: {
    // stream information
    stream: {
      type: Object,
      default: null
    },
    // is modal shown
    show: {
      type: Boolean,
      default: false
    },
    // is modal loading
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      /** error description */
      errorMessage: "",
      /** changed parameters */
      form: {
        /** new restreaming URL */
        streamUrl: null,
        streamDisplayName: null
      }
      // copyStreamUrl: null,
      // copyStreamDisplayName: null
    };
  },
  computed: {
    // @vuese
    // Channel name or default name (if channel not added on Mangomolo)
    title() {
      return this.stream?.channelName ?? "---";
    },
    // @vuese
    // Is here some changes between origin stream data and new one
    isChanged() {
      return (
        this.stream.streamUrl !== this.form.streamUrl ||
        this.stream.streamDisplayName !== this.form.streamDisplayName
      );
    },
    // @vuese
    // Array of form error messages
    errors() {
      const errorsList = [];

      if (!this.streamUrlValidStatus.valid) {
        errorsList.push(this.streamUrlValidStatus.error);
      }

      if (!this.isChanged) {
        errorsList.push("Stream is not changed");
      }

      return errorsList;
    },
    // @vuese
    // Is stream URL valid
    streamUrlValidStatus() {
      const url = this.form.streamUrl;

      try {
        new URL(url);
      } catch {
        return {
          valid: false,
          error: "Stream URL must be a valid URL"
        };
      }

      return {
        valid: true
      };
    }
  },
  watch: {
    // @vuese
    // Update stream at change
    stream() {
      if (this.stream !== null) {
        this.form = {
          streamUrl: this.stream.streamUrl,
          streamDisplayName: this.stream.streamDisplayName
        };
        // this.copyStreamUrl = this.stream.streamUrl,
        // this.copyStreamDisplayName = this.stream.streamDisplayName
      }
    }
  },
  methods: {
    // @vuese
    // Accept stream editing
    editStream() {
      if (
        this.stream.streamUrl !== this.form.streamUrl &&
        this.stream.streamDisplayName !== this.form.streamDisplayName
      ) {
        this.$emit("editStream", this.form);
      } else if (
        this.stream.streamDisplayName !== this.form.streamDisplayName
      ) {
        this.$emit("editStream", {
          streamDisplayName: this.form.streamDisplayName
        });
      } else if (this.stream.streamUrl !== this.form.streamUrl) {
        this.$emit("editStream", { streamUrl: this.form.streamUrl });
      }
    },
    // @vuese
    // Edit stream if it's modal, otherwise show error message
    trySubmit() {
      /** Errors and loading prevent to submit modal */
      if (!this.errors.length && !this.loading) {
        this.editStream();
      } else if (this.errors.length) {
        this.validateModal();
      }
    },
    // @vuese
    // Show modal errors
    validateModal() {
      if (this.errors.length) {
        this.errorMessage = this.errors[0];
      } else {
        this.clearError();
      }
    },
    // @vuese
    // Erase error message
    clearError() {
      this.errorMessage = "";
    },
    // @vuese
    // Hide modal
    closeModal() {
      // User try to close modal
      this.$emit("close");
      /** clear errors after closing so it not will appear for new stream */
      this.clearError();
    }
  }
};
</script>

<style>

.marginBlock{
  margin-top: 10px;
}
</style>

<style scoped>
.modal__row {
  display: flex;
  flex-direction: column;
}

</style>
